// extracted by mini-css-extract-plugin
export default {"actions":"actions_actions__NYo8X"};